import { render, staticRenderFns } from "./BiddingMethod.vue?vue&type=template&id=21a7ca68&scoped=true"
import script from "./BiddingMethod.vue?vue&type=script&lang=js"
export * from "./BiddingMethod.vue?vue&type=script&lang=js"
import style0 from "./BiddingMethod.vue?vue&type=style&index=0&id=21a7ca68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7ca68",
  null
  
)

export default component.exports